import React, { useState, useEffect } from 'react';
import 'styles/main.css';

import moment from 'moment';
import update from 'immutability-helper'

import API from 'files/api.js';
import AFTPrivacyPolicy from 'views/AFTPrivacyPolicy.js';
import Alert from 'views/Alert.js';
import AlertStack from 'views/AlertStack.js';
import Appearance from 'styles/Appearance.js';
import GDLPrivacyPolicy from 'views/GDLPrivacyPolicy.js';
import Loader from 'views/Loader.js';
import ProgramContent from 'views/ProgramContent.js';
import QueryString from 'query-string';
import Sheet from 'views/Sheet.js';

window.theme = 'light';
const App = () => {

    const [alerts, setAlerts] = useState([]);
    const [loader, setLoader] = useState(null);
    const [nonce, setNonce] = useState(moment().unix());
    const [size, setSize] = useState({ width: window.innerWidth, height: window.innerHeight });
    const [sheet, setSheet] = useState(null);
    const type = 'aft_privacy_policy';

    const utils = {
        alert: {
            show: async props => {
                try {
                    if(loader) {
                        await utils.loader.hide();
                    }
                    setAlerts(alerts => update(alerts, {
                        $push: [{
                            id: `${moment().unix()}-${Math.random()}`,
                            ...props
                        }]
                    }))
                } catch(e) {
                    console.error(e.message)
                }
            }
        },
        api: {
            headers: () => {
                return {
                    'Content-Type': 'application/json',
                    'X-API': `Version ${API.version}`,
                    'X-Timezone': `TZ ${moment.tz.guess()}`
                }
            }
        },
        loader: {
            show: async () => {
                return new Promise(resolve => {
                    setLoader(true);
                    setTimeout(resolve, 500)
                })
            },
            hide: async () => {
                return new Promise(resolve => {
                    setLoader(false);
                    setTimeout(resolve, 500)
                })
            }
        },
        sheet: {
            show: (sheet, callback) => {
                setSheet({ ...sheet, onClick: callback })
            }
        }
    }

    const onSetStyleSheetProperties = () => {
        document.body.className = window.theme;
        document.documentElement.style.setProperty('--theme', window.theme);
        document.documentElement.style.setProperty('--text', Appearance.colors.text());
        document.documentElement.style.setProperty('--textfield', Appearance.colors.textField());
        document.documentElement.style.setProperty('--soft_border', Appearance.colors.softBorder());
    }

    const onUpdateTheme = evt => {
        window.theme = evt.matches ? 'dark' : 'light';
        onSetStyleSheetProperties();
        setNonce(moment().unix());
    }

    const onWindowSizeChange = () => {
        setSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    }

    const getContent = () => {

        let props = QueryString.parse(window.location.search);
        switch(type) {
            case 'aft_privacy_policy':
            return <AFTPrivacyPolicy />

            case 'care_and_share':
            document.title = 'Care and Share Agreement';
            return (
                <ProgramContent
                {...props}
                utils={utils}
                type={type} />
            )

            case 'custom_program':
            return (
                <ProgramContent
                {...props}
                utils={utils}
                type={type} />
            )

            case 'gdl_privacy_policy':
            return <GDLPrivacyPolicy />

            default:
            return null;
        }
    }

    useEffect(() => {

        // setup window size change listener
        window.addEventListener('resize', onWindowSizeChange);

        // css variables
        document.documentElement.style.setProperty('--text', Appearance.colors.text());
        document.documentElement.style.setProperty('--textfield', Appearance.colors.textField());
        document.documentElement.style.setProperty('--soft_border', Appearance.colors.softBorder());

        // theme and theme listeners
        window.theme = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        document.documentElement.style.setProperty('--theme', window.theme);
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', onUpdateTheme);
        onSetStyleSheetProperties();

    }, []);

    return (
        <div
        id={'root-container'}
        className={`root-container ${window.theme}`}
        nonce={nonce}
        style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            height: size.height,
            backgroundColor: Appearance.colors.layerBackground(),
            overflow: 'hidden',
            maxHeight: '100vh',
            overflowY: 'scroll'
        }}>
            <div style={{
                maxWidth: 750,
                padding: 20
            }}>
                <div style={{
                    width: '100%',
                    height: '100%'
                }}>
                    {getContent()}
                    <div style={{ height: 125 }} />
                </div>
            </div>
            <Loader animate={loader}/>
            <AlertStack>
                {alerts.map((alert, index) => (
                    <Alert {...alert}
                    key={index}
                    utils={utils}
                    index={(alerts.length - 1) - index}
                    onClose={id => {
                        if(typeof(alert.onClose) === 'function') {
                            alert.onClose();
                        }
                        setAlerts(alerts => {
                            return alerts.filter(alert => {
                                return id !== alert.id;
                            });
                        })
                    }} />
                ))}
            </AlertStack>
            {sheet && (
                <Sheet
                {...sheet}
                onClose={() => setSheet(null)}/>
            )}
        </div>
    )
}
export default App;
